import React from "react";

const capabilitiesData = [
  {
    id: 1,
    title: "CRM & Community Engagement",
    image: "/assets/glodesk/img2.png",
    points: [
      "A unified member database that keeps all profiles and interaction history in one place",
      "Easy event management with integrated community feeds for better engagement",
      "A simple ticketing system to quickly handle member support and queries",
      "Designed to keep communication smooth, organized, and user-friendly",
    ],
    hoverColor: "orange",
  },
  {
    id: 2,
    title: "Finance & Operations Analytics",
    image: "/assets/glodesk/img3.png",
    points: [
      "Track revenue and occupancy in real time for better visibility",
      "Automate billing cycles and simplify contract management",
      "Use data-driven insights to optimize space and improve efficiency",
      "Make faster, smarter decisions with clear and reliable reports",
    ],
    hoverColor: "blue",
  },
  {
    id: 3,
    title: "Workspace & Facility Management",
    image: "/assets/glodesk/img4.png",
    points: [
      "Simplify daily operations with easy facility scheduling, asset tracking, and maintenance management",
      "Book desks, meeting rooms, and shared spaces in just a few clicks",
      "Automate invoicing and payment tracking for smooth, stress-free financial handling ",
    ],
    hoverColor: "blue",
  },
];

const CoreCapabilities = () => {
  return (
    <section className="bg-white lg:py-20 py-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start relative max-w-[1440px] mx-auto lg:px-[80px] px-[20px]">
        <div className="lg:col-span-4 lg:sticky lg:top-[120px] self-start space-y-4">
          <h2 className="lg:text-[30px] text-[20px] font-sora font-[600] text-[#01386A] tracking-tight">
            Core Capabilities
          </h2>
          <p className="text-[14px] lg:text-[16px] font-graphik text-[#49577A] font-[500] leading-relaxed">
            We focus on creating real, positive impact for our customers, the industries we work with, and the communities around us.
          </p>
        </div>

        {/* Right Side: Cards */}
        <div className="lg:col-span-8 space-y-8">
          {capabilitiesData.map((item) => (
            <div
              key={item.id}
              className={`group relative flex flex-col md:flex-row items-center gap-8 lg:p-[30px] p-[20px] bg-white border border-[#01386A45] transition-all duration-300 ease-in-out cursor-pointer overflow-hidden
                ${item.hoverColor === "orange"
                  ? "hover:shadow-[0_10px_30px_rgba(226,114,37,0.1)]"
                  : "hover:shadow-[0_10px_30px_rgba(30,87,165,0.1)]"
                }
              `}
            >
              <div className="w-full md:w-[233px] h-[298px] flex-shrink-0 bg-gray-50 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content Section */}
              <div className="flex-1">
                <h3 className="lg:text-[20px] text-[16px] font-[600] font-sora text-[#01386A]  lg:pb-[44px] pb-[20px]">
                  {item.title}
                </h3>
                <ul className="space-y-3.5">
                  {item.points.map((point, index) => (
                    <li key={index} className="flex items-start gap-3 text-[#49577A] font-[500] text-[14px] lg:text-[16px] font-graphik leading-normal">
                      <span className="text-[#E27225] mt-[1px]">
                        &gt;
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div
                className={`absolute bottom-0 left-0 h-[4px] w-full transition-all duration-500 ease-in-out bg-[#01386A]`}
              />
              <div
                className={`absolute bottom-0 left-0 h-[4px] w-0 transition-all duration-500 ease-in-out group-hover:w-full
                  ${item.hoverColor === "orange" ? "bg-[#E27225]" : "bg-[#1E57A5]"}
                `}
              />

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CoreCapabilities;